import { Injectable } from '@angular/core';
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerScanResult,
  CapacitorBarcodeScannerTypeHintALLOption,
} from '@capacitor/barcode-scanner';

@Injectable({
  providedIn: 'root',
})
export class ScanService {
  constructor() {}

  async startScan(): Promise<CapacitorBarcodeScannerScanResult> {
    try {
      // Check camera permission
      // This is just a simple example, check out the better checks below
      //await CapacitorBarcodeScanner.checkPermission({ force: true });

      // make background of WebView transparent
      // note: if you are using ionic this might not be enough, check below
      //BarcodeScanner.hideBackground();
      // Add scanner-active class to make body background transparent
      document.querySelector('body')?.classList.add('scanner-active');

      const result: CapacitorBarcodeScannerScanResult = await CapacitorBarcodeScanner.scanBarcode({
        hint: CapacitorBarcodeScannerTypeHintALLOption.ALL,
        scanButton: true,
        scanText: 'Scan QR Code',
      }); // start scanning and wait for a result

      // Remove scanner-active class
      document.querySelector('body')?.classList.remove('scanner-active');

      return result;
    } catch (error) {
      console.log(error);
      console.log('ScannerService: Error while starting scan');
      throw error;
    }
  }

  async stopScan(): Promise<void> {
    try {
      //await CapacitorBarcodeScanner.stopScan({ resolveScan: false });
      // Remove scanner-active class
      document.querySelector('body')?.classList.remove('scanner-active');
    } catch (error) {
      console.log('ScannerService: Error while stopping scan');
      throw error;
    }
  }
}
